import { Component, Input } from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-banner-image',
  templateUrl: './banner-image.component.html',
  imports: [
    NgClass,
    NgOptimizedImage
  ],
  styleUrls: ['./banner-image.component.scss']
})
export class BannerImageComponent {
  @Input() imageSrc: string = '';
  @Input() fitMode: 'cover' | 'natural' = 'cover';
}
